import { render, staticRenderFns } from "./BrMoneyInput.vue?vue&type=template&id=b9877062"
import script from "./BrMoneyInput.vue?vue&type=script&lang=js"
export * from "./BrMoneyInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports